export default __webpack_public_path__ + "static/media/INXC_logo.5d695c4d.png";